module.exports = __webpack_public_path__ + "img/49.6e719574.svg";